import { type PropsWithChildren } from "react";

import type { PathParamsBase, QueryParamsBase } from "@mpa/toolbox/endpoint/Endpoint";
import type RouteNavigator from "@mpa/toolbox/navigation/Navigator";

import { useLocationPathname } from "./location";

type NavigatorViewProps<
    PathParams extends PathParamsBase,
    QueryParams extends QueryParamsBase,
> = PropsWithChildren<{
    navigator: RouteNavigator<PathParams, QueryParams>;
}>;

export default function NavigatorView<
    PathParams extends PathParamsBase,
    QueryParams extends QueryParamsBase,
>(props: NavigatorViewProps<PathParams, QueryParams>) {
    const pathname = useLocationPathname();
    if (!props.navigator.matches(pathname)) return null;
    return props.children;
}
